import { useRef } from 'react';
import { getAriConfig, toAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import type {
	FeaturesResponse,
	PrefetchedDataGql,
} from '@atlassian/jira-software-backlog-load-agility-graphql-data/src/types.tsx';
import { BACKLOG, DISABLED } from './constants.tsx';

export const getBoardUrl = (projectKey: string, boardId: string): string =>
	`/jira/software/projects/${projectKey}/boards/${boardId}`;

export const getCMPBoardUrl = (projectKey: string, boardId: string): string =>
	`/jira/software/c/projects/${projectKey}/boards/${boardId}`;

export const isBacklogDisabled = (data?: PrefetchedDataGql | null): boolean => {
	if (!data?.boardScope.features) {
		return false;
	}

	return data.boardScope.features.some(
		({ key, status }: FeaturesResponse) => key === BACKLOG && status === DISABLED,
	);
};

const defaultPredicate = () => true;

export const useOnce = (callback: () => void, predicate: () => boolean = defaultPredicate) => {
	const done = useRef(false);

	if (!done.current && predicate()) {
		callback();
		done.current = true;
	}
};

export const getIdFromAri = (ari: string) => {
	const possibleAri = toAri(ari);
	if (possibleAri) {
		return getAriConfig(possibleAri).resourceId;
	}
	return ari;
};

export const useIsCMPBacklogRoute = (): boolean => {
	const route = useCurrentRoute();

	return ['rapidboard-backlog', 'rapidboard-user-backlog', 'rapidboard-backlog-embed'].includes(
		route.name,
	);
};
